import React from 'react';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import WarningIcon from '@mui/icons-material/Warning';
import { twMerge } from 'tailwind-merge';

interface AlertProps {
  type: 'success' | 'error' | 'warning';
  message: string;
  className?: string;
}

const Alert: React.FC<AlertProps> = ({ type, message, className }) => {
  const typeStyles = {
    success: 'bg-success/10 text-success border-success',
    error: 'bg-error/10 text-error border-error',
    warning: 'bg-warning/10 text-warning border-warning',
  };

  const icons = {
    success: <CheckCircleIcon className="mr-2" />,
    error: <ErrorIcon className="mr-2" />,
    warning: <WarningIcon className="mr-2" />,
  };

  return (
    <div
      className={twMerge(
        'flex items-center p-4 rounded-md border',
        typeStyles[type],
        className
      )}
    >
      {icons[type]}
      <span>{message}</span>
    </div>
  );
};

export default Alert;